import React from "react";

export default () => (<svg xmlns="http://www.w3.org/2000/svg" width="15" height="18.2" viewBox="0 0 15 18.2"><path stroke="#000" d="M2.5 0v18.2"/><path stroke="#000" d="M12.5 0v18.2"/><circle fill="#000" cx="2.5" cy="6.1" r="2.5"/><circle fill="#000" cx="12.5" cy="11.1" r="2.5"/></svg>)